module.exports = __webpack_public_path__ + "static/media/trash-alt-solid.2acf9176.svg";